module.exports = __webpack_public_path__ + "img/body-1-lg.74c61bd3.png";